let $ = require('jquery'),
  singleWork = require('./views/singleWork.hbs');

let Work = (function() {
  let priv = {};

  priv.$workGrid = $('.work-grid');
  priv.$workLink = priv.$workGrid.find('.work-link');
  priv.$workContent = $('.work-inner-body');

  /**
   * Get work data
   *
   * @param {String} slug
   * @param {Boolean} pushState
   */
  priv.getWork = function (slug, pushState) {
    return $.get({
      url: '/json/work/' + slug + '/'
    }).then(function (work) {
      if (pushState) {
        history.pushState(JSON.parse(work), '', '/work/' + slug + '/');
      }

      return JSON.parse(work);
    });
  };

  /**
   * Display work
   *
   * @param work
   * @returns {*}
   */
  priv.displayWork = function (work) {
    priv.$workContent.html(singleWork({work}));
    priv.$workContent.trigger('after-work-content-change');

    return work;
  };

  /**
   * Handle work link click
   * @param e
   */
  priv.setActiveWork = function(e){
    e.preventDefault();

    priv.$workContent.trigger('before-work-content-change', [$(this).attr('href')]);
    priv.getWork(priv.getWorkSlug($(this).attr('href')), true).then(priv.displayWork);
  };

  /**
   * Add the active class to the .work element
   */
  priv.setActiveWorkClass = function(workEl) {
    workEl.closest('.work').addClass('active');
  };

  /**
   * Remove the active class from .work element
   */
  priv.removeActiveWorkClass = function () {
    $('.work').removeClass('active');
  };

  /**
   * Get work slug from url
   *
   * @param url
   * @returns {null}
   */
  priv.getWorkSlug = function (url) {
    let reg = /work\/(.*)\/?/gi;
    let match = reg.exec(url);

    if (match !== null) {
      return match[1].replace('/', '');
    } else {
      return null;
    }
  };

  /**
   * Attach the event handlers
   */
  priv.attachHandlers = function () {
    priv.$workContent.on('before-work-content-change', function (e, url) {
      let href = typeof url !== 'undefined' ? url : location.href;
      let activeWorkEl = priv.$workLink.filter('[href="' + href + '"]');

      priv.removeActiveWorkClass();
      priv.setActiveWorkClass(activeWorkEl);
      $(this).addClass('loading-work');
    });

    priv.$workContent.on('after-work-content-change', function () {
      $(this).removeClass('loading-work');
      $('html, body').animate({scrollTop: priv.$workContent.offset().top}, 250);
    });

    priv.$workLink.on('click', priv.setActiveWork);

    $(window).on('popstate', function (e) {
      priv.$workContent.trigger('before-work-content-change');
      priv.displayWork(e.originalEvent.state);
    });
  };

  /**
   * Set initial state
   */
  priv.setInitialState = function () {
    let workSlug = priv.getWorkSlug(location.href);

    if (workSlug !== null && workSlug !== '') {
      let work = priv.getWork(workSlug, false);

      work.then(function (work) {
        history.replaceState(work, '', '/work/' + work.post.post_name + '/')
      });

      // When loading an initial work, trigger an immediate scroll to the work.
      // They delay on the trigger is intended to make the scroll occur after
      // the browser has performed its initial position setting
      setTimeout(function() {
        priv.$workContent.trigger('after-work-content-change');
      }, 500);
    }
  };

  priv.attachHandlers();
  priv.setInitialState();
})();


// WEBPACK FOOTER //
// ./htdocs/content/themes/tpt-national/assets/js/modules/Work/Work.js